import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface ProgramCardProps {
  title: string;
  ageRange: string;
  benefit?: string;
  whoItsFor: string;
  imageUrl: string;
  href: string;
}
export function ProgramCard({
  title,
  ageRange,
  benefit,
  whoItsFor,
  imageUrl,
  href
}: ProgramCardProps) {
  return <div className="group flex flex-col bg-paper rounded-2xl overflow-hidden shadow-soft border border-subtle-gray hover:shadow-xl transition-all duration-300" data-id="element-396">
      <div className="relative h-64 overflow-hidden" data-id="element-397">
        <div className="absolute inset-0 bg-ink/20 group-hover:bg-transparent transition-colors duration-300 z-10" data-id="element-398" />
        <img src={imageUrl} alt={title} className="block w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-399" />
        <div className="absolute top-4 left-4 z-20 bg-storm-red text-white px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-400">
          {ageRange}
        </div>
      </div>
      <div className="p-8 flex flex-col flex-grow" data-id="element-401">
        <h3 className="text-3xl mb-2 text-ink" data-id="element-402">{title}</h3>
        {benefit && <p className="text-storm-red font-bold mb-4" data-id="element-403">{benefit}</p>}
        <p className="text-gray-warm mb-8 flex-grow" data-id="element-404">{whoItsFor}</p>
        <Link to={href} className="inline-flex items-center gap-2 text-ink font-bold uppercase tracking-wide group-hover:text-storm-red transition-colors" data-id="element-405">
          Learn More{' '}
          <ArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-406" />
        </Link>
      </div>
    </div>;
}